import colors from '../colors';
import Spacings from '../Spacings';

interface NavigationTheme {
  topBar: {
    background: string;
  };
}

interface SimpleHeaderTheme {
  background: string;
}

interface HeaderCtaCardTheme {
  topCard: {
    background: string;
  };
}

interface ArticlePreviewCardTheme {
  background: string;
  metaColor: string;
  titleColor: string;
  hoverColor: string;
  categoryBackground: string;
  tagColor: string;
  paddingTextContainer: {
    default: string;
    xl: string;
  };
  tagPadding: string;
}

interface PaperTheme {
  backgroundColor: string;
}

export interface ComponentsTheme {
  navigation: NavigationTheme;
  simpleHeader: SimpleHeaderTheme;
  headerCtaCard: HeaderCtaCardTheme;
  articlePreviewCard: ArticlePreviewCardTheme;
  paper: PaperTheme;
}

export const bisComponentsTheme: ComponentsTheme = {
  navigation: {
    topBar: {
      background: colors.abnNeutral20,
    },
  },
  simpleHeader: {
    background: colors.abnGreen500,
  },
  headerCtaCard: {
    topCard: {
      background: colors.abnGreen500,
    },
  },
  articlePreviewCard: {
    background: colors.white,
    metaColor: colors.abnMutedGreen400,
    titleColor: colors.abnBlack,
    hoverColor: colors.abnGreen300,
    categoryBackground: colors.abnMutedGreen50,
    tagColor: colors.abnMutedGreen300,
    paddingTextContainer: {
      default: Spacings.M,
      xl: `${Spacings.L} 40px`,
    },
    tagPadding: Spacings.XS,
  },
  paper: {
    backgroundColor: colors.white,
  },
};
